import React from "react";
import { motion } from "framer-motion";

function CardStory({ story ,t}) {
  return (
    <div
      className=" m-auto z-40 w-11/12 md:w-11/12 max-w-lg md:max-w-4xl h-fit 
                 rounded-tl-3xl rounded-br-3xl bg-gradient-to-br from-[#0EAE2C] via-[#08a32a] to-[#068D1F] 
                 text-gray-100 flex flex-col justify-center py-3 px-4 md:py-2 md:px-8 
                 shadow-2xl border-2 border-white/20 transition-all duration-500 ease-out 
                 group overflow-hidden text-center"
    >
      {/* Title */}
      <h1 className="font-bold text-xl sm:text-2xl md:text-3xl  drop-shadow-md mb-3 md:mb-4">
        {t("ourStory")}
      </h1>

      {/* Description */}
      <p
        dangerouslySetInnerHTML={{ __html: story?.description }}
        className="text-sm   break-words  tracking-wide leading-relaxed animate-text-fade"
      />

      {/* Shine effect */}
      {/* <motion.div
        initial={{ x: "-150%" }}
        animate={{ x: "150%" }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "loop",
          ease: "linear",
        }}
        className="absolute inset-0 overflow-hidden rounded-tl-3xl rounded-br-3xl"
      >
        <div className="absolute -top-[100%] -left-[50%] w-[200%] h-[200%] bg-gradient-to-r from-transparent via-white/20 to-transparent rotate-45" />
      </motion.div> */}
    </div>
  );
}

export default CardStory;
